import { z } from 'zod';

export const productsSchema = z.union([
  z.object({
    aliasId: z.number(),
    stoichiometry: z.number().nullable(),
    type: z.optional(z.string()),
  }),
  z.object({
    element: z.number(),
    stoichiometry: z.number().nullable(),
    type: z.optional(z.string()),
  }),
]);
